module.exports = __webpack_public_path__ + "img/icon_camera_gray.ab524412.svg";